(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lovirs-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lovirs-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-lovirs-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-lovirs-dot]'));
    let activeIndex = 0;
    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === activeIndex); slide.hidden = i !== activeIndex; });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === activeIndex); dot.setAttribute('aria-pressed', String(i === activeIndex)); });
    };
    carousel.querySelector('[data-lovirs-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    carousel.querySelector('[data-lovirs-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => showSlide(i)));
    showSlide(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  function initMylilanBackToTop() {
    const sentinel = document.querySelector('[data-product-description-end]');
    const buttons = [
      ...document.querySelectorAll('[data-product-back-to-top]'),
      ...document.querySelectorAll('.mylilan-mobile-back-to-top')
    ];

    if (!sentinel || buttons.length === 0) return;

    const setVisible = (visible) => {
      buttons.forEach((button) => {
        button.classList.toggle('is-visible', visible);
      });
    };

    buttons.forEach((button) => {
      if (button.dataset.backToTopReady === 'true') return;
      button.dataset.backToTopReady = 'true';

      button.addEventListener('click', (event) => {
        const target =
          document.querySelector('.mylilan-product-top-anchor') ||
          document.querySelector('#MainContent');

        if (!target) return;

        event.preventDefault();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    if (sentinel._mylilanBackToTopObserver) {
      sentinel._mylilanBackToTopObserver.disconnect();
    }

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const reachedDescriptionEnd =
        entry.isIntersecting || entry.boundingClientRect.top <= window.innerHeight;

      setVisible(reachedDescriptionEnd);
    }, {
      root: null,
      threshold: 0
    });

    observer.observe(sentinel);
    sentinel._mylilanBackToTopObserver = observer;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMylilanBackToTop);
  } else {
    initMylilanBackToTop();
  }

  document.addEventListener('shopify:section:load', initMylilanBackToTop);

  } catch(e) { console.error(e); }
})();
})();
